/* eslint-disable camelcase */
import React from 'react';
import {
  PlusOutlined,
  RiseOutlined,
  StarOutlined,
  ThunderboltOutlined,
  TeamOutlined,
  CheckCircleOutlined,
  MinusCircleOutlined,
  LockOutlined,
} from '@ant-design/icons';

const commitmentLevelConfig = {
  new_item: {
    icon: <PlusOutlined style={{ color: '#4B9FFF' }} />,
  },
  high_level_roadmap: {
    icon: <RiseOutlined style={{ color: '#FFA500' }} />,
  },
  prioritized_backlog: {
    icon: <StarOutlined style={{ color: '#E5A600' }} />,
  },
  committed_delivery: {
    icon: <ThunderboltOutlined style={{ color: '#6ABF4B' }} />,
  },
  third_party_development: {
    icon: <TeamOutlined style={{ color: '#4B9FFF' }} />,
  },
  delivered: {
    icon: <CheckCircleOutlined style={{ color: '#6ABF4B' }} />,
  },
  deprioritized: {
    icon: <MinusCircleOutlined style={{ color: '#8C8C8C' }} />,
  },
  archived: {
    icon: <LockOutlined style={{ color: '#595959' }} />,
  },
};

export default commitmentLevelConfig;
